export const tvbetFrameUrl = 'tvbetframe10.com';
export const tvbetClientId = 9896;
